/* globals lp, jui, eventTracker, Class */
var videoValidation = require('ub/elements/video/video-validation.js').default;

var rxUi = window.rxUi;

module.exports = Class.create(
  lp.editor.BuilderModal,
  lp.ModuleComponent,
  {
    type:'lp-pom-video',

    initialize: function($super){
      this.controls = {};
      var self = this;

      $super({
        title: 'Embed a Video',
        actions: [{
          id: 'done',
          class: 'save-code-button action',
          label: 'Save Code',
          action: this.embed.bind(this)
        },
        {
          id: 'cancel',
          class: 'push-left',
          label: 'Discard',
          action: function() {
            self._uiBinding.onNext({
              type: 'cancel'
            });
          }
        }],
        attributes: {
          className: 'modal-panel code-video-panel'
        },
        layoutRules: {
          method: lp.editor.BuilderModal.fitToViewport,
          options: {
            padding: 12,
            size:{width:1000, height:600}
          }
        },
        closeX: true
      });
    },

    installUI: function( $super ) {
      $super();

      this._uiBinding = new rxUi.Binding('VideoEditor')
        .subscribeDomainEvents(this.domainEvents, this);

      this.warn = this.actionBar.insert( new Element('div', {className:'warn'})
        .update('You must enter valid code'));

      var self = this;
      var clearWarning = function() { self.warn.hide(); };

      this.controls.codeEditor = this.contentPanel.insert( new jui.CodeEditor( {
       label: 'Paste your video code below:',
       toggleCheckboxYPosition: '5px',
       onKeyup: clearWarning,
       onMouseup: clearWarning,
       onChange: function() { self.warn.hide(); }
      } ) );

      this.warn.hide();
    },

    requestFocus: function(){
      window.editor.keyController.requestFocus(this);
    },

    onkeydown: function() {},

    onkeyup: function(){
      this.warn.hide();
    },

    blur: function(){
    },

    embed: function() {
      // Called when the embed button is clicked on the input window.
      this._uiBinding.onNext({
        type : 'save',
        html : this.controls.codeEditor.getValue()
      });

      if (typeof eventTracker !== 'undefined') {
        eventTracker.track("Add a Video", "Editor");
      }
    },

    open: function($super, elm, options) {
      $super();
      //Called when the video element input window opens.
      if (options && options.callback) {
        this.options.callback = options.callback;
      }

      var content = elm !== null ? elm.model.getVideoContent() : '';
      this.controls.codeEditor.setValue(content);
      this.controls.codeEditor.focus();
      this.requestFocus();
    },

    close: function($super) {
      delete this.options.callback;
      this.warn.hide();
      $super();
    },

    validEmbedCode: function(embedCode) {
      var codeState = videoValidation.validate(embedCode);

      if (!codeState.valid) {
        this.warn.update(codeState.warning);
        this.warn.show();
      }

      return codeState;
    },

    domainEvents: {
      cancel: function() {
        this.close();
      },

      save: function(ev) {
        if ( ! this.options.callback) { return; }

        var codeState = this.validEmbedCode(ev.html);

        if (codeState.valid) {
          this.options.callback({
            html: codeState.content
          });

          this.close();
        }
      }
    }
  }
);



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/modules/lp-video/video_element_builder.js
// module id = 1471
// module chunks = 0